import { ProductType } from '@/shared/enums';
import { getSeasonAndEpisode } from '@/shared/plugins/stats/helpers';

const getProductTitle = (product, options = {}) => {
  let title = '';
  const productTitle = options.original && product?.originalTitle ? product.originalTitle : product?.title || '';

  if (product.type === ProductType.EPISODE) {
    title = getProductTitle(product.season.serial, options);
    if (options.detailPage) {
      title += ' | ';
      const seasonAndEpisode = getSeasonAndEpisode(product);
      if (seasonAndEpisode) {
        title += `${seasonAndEpisode}: `;
      }
      if (productTitle) {
        title += `${productTitle}`;
      }
    }
  } else if (product.type === ProductType.PROGRAMME) {
    if (productTitle) {
      title = productTitle;
    }
  } else {
    title = options.richTitle
      ? `<strong>${productTitle}</strong>`
      : productTitle;

    if (options.year && product.year) {
      title += ` (${product.year})`;
    }
  }

  return title;
};

export default getProductTitle;
